import { render, staticRenderFns } from "./WhatMadeWhitePollutionView.vue?vue&type=template&id=e6d84ba8&scoped=true&"
import script from "./WhatMadeWhitePollutionView.vue?vue&type=script&lang=js&"
export * from "./WhatMadeWhitePollutionView.vue?vue&type=script&lang=js&"
import style0 from "./WhatMadeWhitePollutionView.vue?vue&type=style&index=0&id=e6d84ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d84ba8",
  null
  
)

export default component.exports